module.exports = __webpack_public_path__ + "img/item2.cfe1c6ee.png";